import React from 'react';
import { Box } from '@mui/material';
import { DefaultLayout } from '../../components/layout/default-layout';
import { useMetaTitle } from '../../hooks';
import { useFeatureToggles } from '../../feature-toggles';
import { PageNotFound } from '../../404';
import { useIsAllowed } from '../../authentication/use-is-allowed';
import { ResourceOperations, ResourceTypes } from '../../authentication/resources';
import { OFFER_RESOURCE_IMPROVEMENTS_TOGGLE } from '../offer-and-activity/offer-resource/offer-resource-improvements';
import { ResourceUtilization } from './resource-utilization-container';

const resourceUtilizationAccess = [{ resourceType: ResourceTypes.ResourceUtilization, resourceOperation: ResourceOperations.Read }];

function ResourceUtilizationContent() {
  useMetaTitle('Ressourceforbrug');

  return (
    <Box sx={{ px: 2, pt: 3, pb: 6, maxWidth: 1320, mx: 'auto' }}>
      <ResourceUtilization />
    </Box>
  );
}

export function ServiceProviderResourceUtilizationPage() {
  const { isFeatureEnabled } = useFeatureToggles();
  const isAllowed = useIsAllowed(resourceUtilizationAccess);

  if (!isFeatureEnabled(OFFER_RESOURCE_IMPROVEMENTS_TOGGLE) || !isAllowed) {
    return <PageNotFound />;
  }

  return (
    <DefaultLayout>
      <ResourceUtilizationContent />
    </DefaultLayout>
  );
}
